{partitionAndSort} = require('../../utils')

module.exports = (
  $scope,
  $uibModal,
  $state,
  $q,
  $filter,
  Api,
  projectPermissions,
  researchRequests,
  Assembler,
  $rootScope,
  ManualSourceBreakdown,
  iterations ) ->

  # =========================
  # -------- Actions --------
  # =========================

  $scope.uploadDoc = (source) ->
    requestModal = $uibModal.open
      template: require('../StarredDocumentUpload/starred-doc-upload-modal.html')
      controller: 'StarredDocumentUploadController'
      size: 'lg'
      resolve:
        workflowStep: () ->
          return id: source.workflow_step
        manualSource: () ->
          return source.id
    requestModal.result.then (starredDocuments) ->
      if starredDocuments.docs[0]
        ($scope.manualUploads[starredDocuments.docs[0].manual_source] ?= []).push starredDocuments.docs...

  $scope.getSourceById = ( id ) ->
    (step for step in $scope.manualSteps when step.id is parseInt( id, 10 ) )[0]

  $scope.ignoreSelected = () ->
    ignore = []
    for key, step of $scope.manualSelected when step is true and $scope.getSourceById(key).state != 'ignore'
      ignore.push new Api.ManualWorkflowStepIteration(id:key, state:'ignore').$update()
    $q.all(ignore).then (result)->
      for step in result
        pos = $scope.manualWorkflowSteps[step.workflow_step].map((x) -> x.id).indexOf(step.id)
        $scope.manualWorkflowSteps[step.workflow_step][pos].state = 'ignore'
      $scope.onSourceStateChange()

  getVisibleSources = () ->
    $filter('sourceState')( $scope.manualSteps, $scope.filter )

  $scope.selectAll = () ->
    $scope.manualSelected[ source.id ] = true for source in getVisibleSources()

  $scope.deselectAll = () ->
    for stepId, step of $scope.manualSelected
      $scope.deselectSource( stepId )

  $scope.deselectSource = ( aStepId ) ->
    $scope.manualSelected[ aStepId ] = false

  $scope.allVisibleAreSelected = () ->
    for source in getVisibleSources()
      selected = $scope.manualSelected[ source.id ] == true
      if not selected
        return false
    true

  $scope.hasSelection = () ->
    $scope.selectedCount > 0

  $scope.setFilter = (filter) ->
    $scope.filter = filter
    $scope.deselectAll()

  $scope.onSourceStateChange = () ->
    $scope.sourceBreakdown.refresh()
    $scope.deselectAll()

  $scope.$on 'manual source state changed', ( aEvent, aStep )->
    $scope.sourceBreakdown.refresh()
    $scope.deselectSource( aStep.id )

  $scope.workflowStepHasNoVisibleChildren = (stepId) ->
    visibleChildren = $filter('sourceState')( $scope.manualWorkflowSteps[stepId], $scope.filter )
    visibleChildren.length == 0

  $scope.workflowHasNoVisibleChildren = (workflowId) ->
    steps = $scope.allWorkflowSteps[workflowId]
    for stepKey, step of steps
      if !$scope.workflowStepHasNoVisibleChildren( step.id )
        return false
    true

  $scope.shouldShowWorkflowStep = (stepId) ->
    $scope.filter == 'all' || !$scope.workflowStepHasNoVisibleChildren(stepId)

  $scope.shouldShowWorkflow = (workflowId) ->
    $scope.filter == 'all' || !$scope.workflowHasNoVisibleChildren(workflowId)


  # =========================
  # --------- Scope ---------
  # =========================

  $scope.projectPermissions = projectPermissions
  $scope.filter = 'todo'

  $scope.$watch 'filter', () ->
    $scope.deselectAll()

  $scope.$watchCollection 'manualSelected', () ->
    $scope.selectedCount = (s for k, s of $scope.manualSelected when s is true).length

  if not $scope.hasManualSteps
    $state.go('project.export')

  $scope.iterations = {}
  for iteration in iterations
    $scope.iterations[iteration.id] ?= iteration

  $scope.manualChecksGroupedByIteration = {}
  for manualStep in $scope.manualSteps
    $scope.manualChecksGroupedByIteration[manualStep.workflow_step] ?= {}
    $scope.manualChecksGroupedByIteration[manualStep.workflow_step][manualStep.iteration] ?= []
    $scope.manualChecksGroupedByIteration[manualStep.workflow_step][manualStep.iteration].push(manualStep)

  $scope.manualWorkflowSteps = partitionAndSort($scope.manualSteps, 'workflow_step', 'workflow_step')
  $scope.setResearchRequests( researchRequests )
  Assembler.linkArrayItems( $scope.manualSteps, 'request', $scope.researchRequests, 'manual_step' )

  $scope.allWorkflows = partitionAndSort($scope.workflows, 'id', 'id')

  $scope.manualSelected = {}
  for stepId in (step.id for step in $scope.manualSteps)
    $scope.manualSelected[stepId] = false

  $scope.sourceBreakdown = new ManualSourceBreakdown( $scope.manualSteps )
